import { render, staticRenderFns } from "./sessions.vue?vue&type=template&id=3b7a88ac"
import script from "./sessions.vue?vue&type=script&lang=ts"
export * from "./sessions.vue?vue&type=script&lang=ts"
import style0 from "./sessions.vue?vue&type=style&index=0&id=3b7a88ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports